export default function generateCSSSelector(className) {
  var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var specificityPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return specificityPrefix + '.' + className + pseudo;
}